import React from 'react';
import getclassNames from '../../utils/getClassNames';
import './WarningMessages.css';

export interface WarningMessagesProps {
    messages?: string[];
    children?: React.ReactNode;
    containerClassName?: string;
    messageClassName?: string;
    showIcon?: boolean;
}

const WarningMessages = (props: WarningMessagesProps) => {
    if ((!props.messages || props.messages.length === 0) && !props.children) {
        return null;
    }

    return (<div className={getclassNames('warning-container', props.containerClassName || '')}>
        {props.messages?.map((m, i) => {
            return <div className={getclassNames('warning-message', props.messageClassName || '')} aria-live="polite" key={i}>
                {props.showIcon && <i className="ri-alert-line warning-message-icon" aria-hidden="true"></i>} {m}
            </div>
        })}
        {props.children && <div className={getclassNames('warning-message', props.messageClassName || '')} aria-live="polite">
            {props.showIcon && <i className="ri-alert-line warning-message-icon" aria-hidden="true"></i>} {props.children}
        </div>}
        </div>);
};

export default WarningMessages;
